import React from 'react'

function ModalAccepted({ isOpen, onClose, consultation }) {
  if (!isOpen) return null;

   // Helper to format date as dd-mm-yy
   const formatDate = (isoString) => {
    if (!isoString) return ""; // or "N/A"
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  // Helper to format time in AM/PM
  const formatTime = (time) => {
    if (!time) return ""; // or "N/A"
    const [hours, minutes] = time.split(":");
    const parsedHours = parseInt(hours, 10);
    const ampm = parsedHours >= 12 ? "PM" : "AM";
    const formattedHours = parsedHours % 12 || 12; // Convert to 12-hour format
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="p-6 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-semibold">Consultation Details</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>

        {/* Content - Scrollable */}
        <div className="p-6 overflow-y-auto">
          <div className="space-y-6">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-4">Basic Information</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Consultation ID</label>
                  <p className="mt-1 text-sm text-gray-900">{consultation?.consultationId}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Student Name</label>
                  <p className="mt-1 text-sm text-gray-900">{consultation?.studentName}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Email</label>
                  <p className="mt-1 text-sm text-gray-900">{consultation?.email}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Cell Phone</label>
                  <p className="mt-1 text-sm text-gray-900">{consultation?.cellPhone}</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-4">Consultation Details</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Date</label>
                  <p className="mt-1 text-sm text-gray-900">{formatDate(consultation?.consultationDate)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Time</label>
                  <p className="mt-1 text-sm text-gray-900">{formatTime(consultation?.consultationTime)}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Consultant</label>
                  <p className="mt-1 text-sm text-gray-900">{consultation?.consultantName}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">Meeting Link</label>
                  <a
                    href={consultation?.meetingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-1 text-sm text-blue-600 hover:text-blue-800"
                  >
                    {consultation?.meetingLink}
                  </a>
                </div>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <span className="mt-1 inline-block px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm">
                Approved
              </span>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium mb-4">Consultant Review</h3>
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700">Review</label>
                <p className="mt-1 text-sm text-gray-900 whitespace-pre-wrap bg-white p-3 rounded border border-gray-200 min-h-[100px]">
                  {consultation?.consultantReview || 'No review available'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t mt-auto">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-700 rounded hover:bg-gray-700 hover:text-white"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalAccepted;